<template>
  <validation-observer class="message" ref="observer" tag="div" v-slot="{handleSubmit, invalid}">
    <form @submit.prevent="handleSubmit(sendRm)">
      <validation-provider rules="required" name="メッセージ">
        <textarea @keyup.enter.ctrl="sendRm" name="direct_message" v-model="message" placeholder="メッセージを入力" />
      </validation-provider>
      <input type="submit" class="btn" :disabled="invalid" value="送信" />
    </form>
  </validation-observer>
</template>

<script>
export default {
  name: "RoomMessageForm",
  data() {
    return {
      message: null
    }
  },
  methods: {
    sendRm: async function() {
      const isValid = await this.$refs.observer.validate()

      if (!isValid) return

      this.$emit("dispatch-rm", this.message)
      this.message = null
    }
  }
}
</script>
